import { InputData } from "./InputData";

export class BoolInput extends InputData
{
  value:boolean;
}